import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Check, ChevronDown, Users } from "lucide-react";

export const UNGROUPED = "__UNGROUPED__";

export const groupOptions = (names) => [{ key: UNGROUPED, label: "Belum Dikelompokkan" }, ...names.map((n) => ({ key: n, label: n }))];

export const matchGroups = (sel, group) => sel.length === 0 || sel.includes(group || UNGROUPED);

export const groupsQS = (sel) => (sel.length ? `group=${encodeURIComponent(sel.join(","))}` : "");

export const GroupChecklist = ({ names, value, onChange, testid = "group" }) => {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  const Item = ({ k, label, on, onClick }) => (
    <button type="button" data-testid={`${testid}-option-${k}`} onClick={onClick}
      className={`flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-left text-sm transition-colors ${on ? "bg-blue-50 text-blue-800" : "text-slate-700 hover:bg-slate-50"}`}>
      <span className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border ${on ? "border-blue-600 bg-blue-600 text-white" : "border-slate-300 bg-white"}`}>
        {on && <Check className="h-3 w-3" />}
      </span>
      {label}
    </button>
  );
  return (
    <div className="space-y-0.5">
      <Item k="ALL" label="Semua Kelompok" on={value.length === 0} onClick={() => onChange([])} />
      {groupOptions(names).map((o) => <Item key={o.key} k={o.key} label={o.label} on={value.includes(o.key)} onClick={() => toggle(o.key)} />)}
    </div>
  );
};

export const GroupMultiFilter = ({ names, value, onChange, testid }) => {
  const label = value.length === 0 ? "Semua Kelompok"
    : value.length === 1 ? (value[0] === UNGROUPED ? "Belum Dikelompokkan" : value[0]) : `${value.length} kelompok dipilih`;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid={testid} className="flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm font-medium text-slate-700 outline-none hover:border-blue-400 transition-colors">
          <Users className="h-4 w-4 text-slate-400" /> {label} <ChevronDown className="h-4 w-4 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 p-2">
        <GroupChecklist names={names} value={value} onChange={onChange} testid={testid} />
      </PopoverContent>
    </Popover>
  );
};
